
/// <amd-module name="Test/TestResultsGrid/Actions/TestResultsGridActionHub" />
import { Action } from "VSS/Reflux/Action";
import * as TCMContracts from "Test/common-util/Contracts/Test";
import { ITestResultTreeData } from "Test/common-util/Contracts/ViewContracts";
import { FilterState } from "Test/common-util/Contracts/Filters"

export class TestResultsGridActionsHub {
    public initializeTestResults = new Action<TCMContracts.TestResultsDetails | null>();
    public onGroupByChanged = new Action<string>();
    public filterChanged = new Action<FilterState>();
    public onGridColumnChanged = new Action<string[]>();
    public shallowResultsFetched = new Action<ShallowTestCaseResultData>();
    public groupedResultsFetched = new Action<TCMContracts.TestResultsDetails>();
    public loadStageData = new Action<TCMContracts.TestResultsDetails>();
    public onFetchMoreResults = new Action<void>();
    public onError = new Action<string>();
    public onWarning = new Action<string>();
    public onSelectionChange = new Action<ITestResultTreeData[]>();
    public sortDataInGridAndToggleState = new Action<void>();
    public onChangedToDefaultFilters = new Action<FilterState>();
    public onTestTagSummaryFetched = new Action<TCMContracts.TestTagSummary>();
    public onMarkTestResultFlaky = new Action<void>();
    public handleRunLevelResultCount = new Action<void>();
    public handleRunSummaryCountMismatch = new Action<void>();
}

export class TestResultsLeftViewActionHub {
    public enableViewMoreTests = new Action<void>();
}

export class TestResultsToGroupMap {
    groupId: string;
    results: TCMContracts.TestResultsQuery;
    testCaseResultDetails?: TCMContracts.TestCaseResult;
}

export class ShallowTestCaseResultData {
    shallowResults: TCMContracts.ShallowTestCaseResult[];
    isResultFetchedFromServer: Boolean;
}
